export const cardHelpers = {
  methods: {
    getCommandCard (event) {
      return event.requirementsJson?.filter((card) => card.cardType?.triggerType).sort((a, b) => a.sortkey.localeCompare(b.sortkey))[0] || null
    },
    getQueryCards (event) {
      return event.requirementsJson?.filter((card) => card.cardType?.queryType).sort((a, b) => a.sortkey.localeCompare(b.sortkey)) || []
    },
    getEntityCard (event) {
      return event.requirementsJson?.find((card) => card.cardType?.aggregateType) || null
    },
    getGwtCards (event) {
      return event.requirementsJson?.filter((card) => card.cardType?.gwtType) || []
    },
    getCommandName (event) {
      const command = this.getCommandCard(event)
      return command?.description?.replace(/<\/?p>/g, '') // remove p tags
    },
    getEntityName (event) {
      const entity = this.getEntityCard(event)
      return entity?.description?.replace(/<\/?p>/g, '') // remove p tags
    }
  }
}
